import React from 'react'

export const Heading = ({ title }) => {
    return (
        <div className="padding-section" style={{ marginTop: "10px", marginBottom: "20px" }}>
            <div className="heading">{title}</div>
        </div>
    )
}
